module.exports = __webpack_public_path__ + "img/triste.5b86adf1.png";